import {useState} from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import FlightCarrierForm from "./FlightCarrierForm";
import styles from "../showName/EditShowName.module.scss";

const EditFlightCarrier = ({ flightCarrier, setFlightCarrier, onUpdate }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    return (
        <>
            <EditOutlinedIcon
                fontSize="small"
                onClick={handleOpen}
                className={`${styles.icon} m-1`}
            />
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle styles={`${styles.header} text-center`}>
                    Edit flight carrier
                </DialogTitle>
                <FlightCarrierForm
                    flightCarrier={flightCarrier}
                    setFlightCarrier={setFlightCarrier}
                    onCancel={handleClose}
                    onUpdate={onUpdate}
                />
            </Dialog>
        </>
    )
}

export default EditFlightCarrier;
